"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isLocalhost() {
    return window.location.hostname === 'localhost';
}
exports.isLocalhost = isLocalhost;
//# sourceMappingURL=utils.js.map